import { createNode } from '@glueapp/graph-types';
import { GoogleDriveIntegration } from './GoogleDriveIntegration';

interface Spreadsheet {
    sheets: {
        properties: {
            sheetId: number;
        };
        data: {
            rowData: {
                values: {
                    formattedValue: string;
                }[];
            }[];
        }[];
    }[];
}

export const GetSpreadsheet = createNode({
    id: 'Get Google Spreadsheet',
    name: 'Get Google Spreadsheet',
    description: 'Get data inside a google spreadsheet',
    aiDescription:
        'Requires the Google Drive integration to be connected. Takes a "spreadsheetId" (string) input port identifying the Google Spreadsheet to read. Outputs a "sheets" port containing an array of sheet objects, each with an "id" and "rows" array where each row contains a "cells" array of string values.',
    category: 'Google Drive',
    color: '#e44232',
    integration: GoogleDriveIntegration,
    inPorts: {
        spreadsheetId: {
            kind: 'string',
        },
    },
    outPorts: {
        sheets: {
            kind: 'array',
            subType: {
                kind: 'object',
                restriction: 'open',
                properties: {
                    id: { kind: 'number' },
                    rows: {
                        kind: 'array',
                        subType: {
                            kind: 'object',
                            restriction: 'open',
                            properties: {
                                cells: {
                                    kind: 'array',
                                    subType: {
                                        kind: 'string',
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    isAsync: true,
    execute: async function (input) {
        try {
            const spreadsheetId = input.inPorts.spreadsheetId;
            const response = await input.integration.callIntegration<Spreadsheet>({
                url: `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}`,
                params: {
                    includeGridData: true,
                },
            });
            const filesResponse: Spreadsheet = response.data;
            return {
                output: {
                    sheets: filesResponse.sheets.map(sheet => ({
                        id: sheet.properties.sheetId,
                        rows: sheet.data[0].rowData.map(row => ({
                            cells: row.values.map(cell => cell.formattedValue),
                        })),
                    })),
                },
            };
        } catch {
            return { output: { sheets: [] } };
        }
    },
});
